import { DataScienceCourse } from './types';
import { MLOPS_MODULE } from './modules/advanced';

export const DATASCIENCE_ADVANCED_COURSE: DataScienceCourse = {
  id: 'datascience-advanced',
  title: 'Advanced Data Science & MLOps',
  description: 'Master production-grade data science with MLOps, big data architecture, advanced analytics, and leadership skills for senior roles.',
  level: 'advanced',
  totalDuration: '18-22 hours',
  image: '/api/placeholder/400/300',
  prerequisites: [
    'Completed Intermediate Data Science course',
    'Solid understanding of machine learning',
    'Experience with Python and SQL',
    'Familiarity with cloud platforms'
  ],
  learningOutcomes: [
    'Implement MLOps best practices and CI/CD for ML',
    'Design scalable big data architectures',
    'Apply causal inference and experimental design',
    'Lead data science teams and strategy',
    'Build domain-specific ML solutions',
    'Implement data governance and quality frameworks',
    'Deploy models at enterprise scale',
    'Drive business value through data science initiatives'
  ],
  modules: [MLOPS_MODULE]
};
